module.exports = __webpack_public_path__ + "img/1Petci.bad28043.svg";